import { CenterLinePoint } from "../types";

export const EMISSIVITY_REFERENCE = 0.875;
export const EMISSIVITY_UPPER = 0.95;
export const EMISSIVITY_LOWER = 0.8;

function normalizeEmissivity(value: number | null | undefined) {
  return Number.isFinite(value) && Number(value) > 0 ? Number(value) : EMISSIVITY_REFERENCE;
}

export function correctTemperatureForEmissivity(
  temperatureC: number,
  sourceEmissivity: number | null | undefined,
  targetEmissivity: number | null | undefined
) {
  if (!Number.isFinite(temperatureC)) return temperatureC;
  const source = normalizeEmissivity(sourceEmissivity);
  const target = normalizeEmissivity(targetEmissivity);
  const temperatureK = temperatureC + 273.15;
  return temperatureK * Math.pow(source / target, 0.25) - 273.15;
}

export function enrichCenterLinePoint(
  point: CenterLinePoint,
  measuredEmissivity: number | null | undefined
): CenterLinePoint {
  return {
    ...point,
    temperature_epsilon_0875: correctTemperatureForEmissivity(
      point.temperature,
      measuredEmissivity,
      EMISSIVITY_REFERENCE
    ),
    temperature_upper: correctTemperatureForEmissivity(
      point.temperature,
      measuredEmissivity,
      EMISSIVITY_UPPER
    ),
    temperature_lower: correctTemperatureForEmissivity(
      point.temperature,
      measuredEmissivity,
      EMISSIVITY_LOWER
    )
  };
}

export function enrichCenterLine(
  points: CenterLinePoint[],
  measuredEmissivity: number | null | undefined
) {
  return points.map((point) => enrichCenterLinePoint(point, measuredEmissivity));
}
